import { faPlay, faStop, faVolume } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import useSound from 'use-sound';
import './CheatSheetPlayer.module.scss';

type Props = {
    onClick: () => void;
    text: any;
    audioFile: string;
    enabled: boolean;
};

export default function CheatSheetPlayer(props: Props) {
    const [play, { stop, isPlaying, sound }] = useSound(props.audioFile);

    useEffect(() => () => stop(), [sound?._src]);

    return (
        <div styleName={`wrapper ${props.enabled ? '' : 'disabled'}`}>
            <CircleButton
                color={!isPlaying ? 'grey' : 'blue'}
                onClick={() => (isPlaying ? stop() : play())}
            >
                <FontAwesomeIcon icon={isPlaying ? faStop : faVolume} />
            </CircleButton>
            <motion.div
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={props.onClick}
                styleName="right "
            >
                {typeof props.text === 'string' ? (
                    <p>{props.text}</p>
                ) : (
                    props.text
                )}
                <FontAwesomeIcon icon={faPlay} />
            </motion.div>
        </div>
    );
}
